import type {
  MetricsType,
  JourneyExternalClickFiltersOptions,
  Filters,
  SelectedFilters,
  SavedDashboardFiltersListData,
  Entity,
  FilterByID,
  SavedDashboardFiltersList,
  SelectedFilterColumnsData,
  CurrentJourneyBreadCrumbData,
} from 'src/types/analytics-genesis';
import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {AnalyticsJourneysExternalClickInsightsActions} from 'src/action-creators/analytics/analytics-journey-click-insights';
import {
  RECEIVE_FILTERS_OPTIONS,
  SET_CURRENT_DASHBOARD,
  SET_CURRENT_DASHBOARD_DRILLDOWN,
  RECEIVE_SAVED_DASHBOARDS,
  SET_SELECTED_FILTERS,
  SET_SELECTED_ENTITIES,
  SET_SELECTED_JOURNEYS,
  SET_SELECTED_DATE_RANGE_AND_FREQUENCY,
  SET_SELECTED_METRICS_TYPE,
  SET_CURRENT_JOURNEY_DATA,
  SET_CHART_FREQUENCY,
  RECEIVE_JOURNEY_OPTIONS,
  RECEIVE_JOURNEY_CLICK_INSIGHTS_TABLE_COLUMNS,
  RECEIVE_TOUCHPOINT_TABLE_COLUMNS,
  RECEIVE_PEOPLE_TABLE_COLUMNS,
  CLEAR_SELECTED_FILTERS,
  SET_NAVIGATION_DOWN,
  SET_NAVIGATION_UP,
  SET_SELECTED_DATES,
  SET_LOADING_DASHBOARD_FILTERS,
} from 'src/action-creators/analytics/analytics-journey-click-insights';


export type AnalyticsJourneysExternalClickInsightsState = {
  filtersOptions: JourneyExternalClickFiltersOptions;
  selectedDateRange: DateRangeWithTimezone;
  selectedDates: {
    [key: string]: DateRangeWithTimezone;
  };
  selectedFilters: {
    [key: string]: SelectedFilters;
  };
  selectedMetricsType: MetricsType;
  selectedEntities: {
    [key: string]: Array<Entity>;
  };
  selectedJourneys: {
    [key: string]: Array<FilterByID>;
  };
  saveDashboardFilterList: {
    [key: string]: SavedDashboardFiltersListData;
  };
  currentDashboard: {
    [key: string]: SavedDashboardFiltersList | null;
  };
  currentJourneyData: CurrentJourneyBreadCrumbData | null;
  chartFrequency: string;
  journeysClickInsightsColumnFilter: SelectedFilterColumnsData | null;
  touchpointColumnFilter: SelectedFilterColumnsData | null;
  peopleColumnFilter: SelectedFilterColumnsData | null;
  isDashboardFiltersLoading: boolean;
  isNavigationDown: boolean | null;
  isNavigationUp: boolean | null;
};

const initialState: AnalyticsJourneysExternalClickInsightsState = {
  selectedFilters: {},
  selectedDates: {},
  selectedEntities: {},
  selectedJourneys: {},
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  selectedMetricsType: 'overview',
  currentJourneyData: null,
  filtersOptions: {
    journey_lifecycle_goal: [],
    journey_business_goal: [],
    journey_category: [],
    journey_status: [],
    recipient_type: [],
    journey_name: [],
    event_name: [],
    event_type: [],
  },
  chartFrequency: 'weekly',
  journeysClickInsightsColumnFilter: null,
  touchpointColumnFilter: null,
  peopleColumnFilter: null,
  saveDashboardFilterList: {},
  currentDashboard: {},
  isDashboardFiltersLoading: true,
  isNavigationDown: null,
  isNavigationUp: null,
};

export default (
  state:
    | AnalyticsJourneysExternalClickInsightsState
    | null
    | undefined = initialState,
  action: AnalyticsJourneysExternalClickInsightsActions,
): AnalyticsJourneysExternalClickInsightsState => {
  switch (action.type) {
    case SET_SELECTED_FILTERS: {
      const {dashboardKey, filters} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ selectedFilters: { [x: string]: SelectedFilters; }; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        selectedFilters: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedFilters,
          [dashboardKey]: filters,
        },
      };
    }
    case SET_SELECTED_ENTITIES: {
      const {dashboardKey, entities} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ selectedEntities: { [x: string]: Entity[]; }; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        selectedEntities: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedEntities,
          [dashboardKey]: entities,
        },
      };
    }
    case SET_SELECTED_JOURNEYS: {
      const {dashboardKey, journeys} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ selectedJourneys: { [x: string]: FilterByID[]; }; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        selectedJourneys: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedJourneys,
          [dashboardKey]: journeys,
        },
      };
    }
    case SET_SELECTED_DATE_RANGE_AND_FREQUENCY: {
      const {chartFrequency, dashboardKey, ...dateRange} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ selectedDateRange: { startDate?: string | null | undefined; endDate?: string | null | undefined; startDateUTC?: string | null | undefined; endDateUTC?: string | null | undefined; timezone?: string; }; ... 15 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        selectedDateRange: dateRange,
        chartFrequency,
        selectedDates: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedDates,
          [dashboardKey]: dateRange,
        },
      };
    }
    case SET_SELECTED_METRICS_TYPE: {
      // @ts-expect-error - TS2322 - Type '{ selectedMetricsType: MetricsType; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {...state, selectedMetricsType: action.payload};
    }
    case SET_CHART_FREQUENCY: {
      // @ts-expect-error - TS2322 - Type '{ chartFrequency: string; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {...state, chartFrequency: action.payload};
    }
    case SET_CURRENT_JOURNEY_DATA: {
      // @ts-expect-error - TS2322 - Type '{ currentJourneyData: { journey?: CurrentJourneyInsightData | null | undefined; }; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; ... 14 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        currentJourneyData: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.currentJourneyData,
          ...action.payload,
        },
      };
    }

    case RECEIVE_FILTERS_OPTIONS: {
      // @ts-expect-error - TS2339 - Property 'filtersOptions' does not exist on type 'AnalyticsJourneysExternalClickInsightsState | null'.
      const {filtersOptions} = state;
      // @ts-expect-error - TS2322 - Type '{ filtersOptions: any; selectedMetricsType: "overview"; selectedDateRange?: DateRangeWithTimezone | undefined; selectedDates?: { [key: string]: DateRangeWithTimezone; } | undefined; ... 12 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        filtersOptions: {
          ...filtersOptions,
          ...action.payload,
        },
        selectedMetricsType: 'overview',
      };
    }
    case RECEIVE_JOURNEY_OPTIONS: {
      // @ts-expect-error - TS2339 - Property 'filtersOptions' does not exist on type 'AnalyticsJourneysExternalClickInsightsState | null'.
      const {filtersOptions} = state;
      // @ts-expect-error - TS2322 - Type '{ filtersOptions: any; selectedDateRange?: DateRangeWithTimezone | undefined; selectedDates?: { [key: string]: DateRangeWithTimezone; } | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        filtersOptions: {
          ...filtersOptions,
          journey_name: action.payload,
        },
      };
    }
    case RECEIVE_JOURNEY_CLICK_INSIGHTS_TABLE_COLUMNS: {
      // @ts-expect-error - TS2322 - Type '{ journeysClickInsightsColumnFilter: SelectedFilterColumnsData; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; ... 14 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {...state, journeysClickInsightsColumnFilter: action.payload};
    }
    case RECEIVE_TOUCHPOINT_TABLE_COLUMNS: {
      // @ts-expect-error - TS2322 - Type '{ touchpointColumnFilter: SelectedFilterColumnsData; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; ... 14 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {...state, touchpointColumnFilter: action.payload};
    }
    case RECEIVE_PEOPLE_TABLE_COLUMNS: {
      // @ts-expect-error - TS2322 - Type '{ peopleColumnFilter: SelectedFilterColumnsData; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; ... 14 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {...state, peopleColumnFilter: action.payload};
    }
    case CLEAR_SELECTED_FILTERS: {
      const {dashboardKey} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ selectedFilters: { [x: string]: SelectedFilters | { journey_lifecycle_goals: never[]; journey_business_goals: never[]; journey_categories: never[]; entity_data_filter: never[]; journey_status: never[]; recipient_type: never[]; journey_ids: never[]; event_types: never[]; }; }; ... 15 more ...; isNavigationUp?: bool...' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        selectedFilters: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedFilters,
          [dashboardKey]: {
            journey_lifecycle_goals: [],
            journey_business_goals: [],
            journey_categories: [],
            entity_data_filter: [],
            journey_status: [],
            recipient_type: [],
            journey_ids: [],
            event_types: [],
          },
        },
        selectedJourneys: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedJourneys,
          [dashboardKey]: [],
        },
        selectedEntities: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedEntities,
          [dashboardKey]: [{id: new Date().getTime()}],
        },
        selectedDates: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedDates,
          [dashboardKey]: {
            startDateUTC: null,
            startDate: null,
            endDateUTC: null,
            endDate: null,
          },
        },
      };
    }
    case SET_CURRENT_DASHBOARD: {
      const {currentDashboard, dashboardKey} = action.payload ?? {};
      const {filters} = currentDashboard ?? {};
      const {journey_ids = []}: Filters = filters ?? {};
      // @ts-expect-error - TS2322 - Type '{ currentDashboard: { [x: string]: SavedDashboardFiltersList | null; }; selectedJourneys: { [x: string]: FilterByID[]; }; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        currentDashboard: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.currentDashboard,
          [dashboardKey]: currentDashboard,
        },
        selectedJourneys: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedJourneys,
          [dashboardKey]: journey_ids,
        },
      };
    }
    case RECEIVE_SAVED_DASHBOARDS: {
      const {filters, dashboard} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ saveDashboardFilterList: { [x: string]: SavedDashboardFiltersListData; }; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; ... 14 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        saveDashboardFilterList: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.saveDashboardFilterList,
          [dashboard]: filters,
        },
      };
    }
    case SET_NAVIGATION_DOWN: {
      // @ts-expect-error - TS2322 - Type '{ isNavigationDown: boolean; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        isNavigationDown: action.payload,
      };
    }
    case SET_NAVIGATION_UP: {
      // @ts-expect-error - TS2322 - Type '{ isNavigationUp: boolean; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; ... 13 more ...; isNavigationDown?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        isNavigationUp: action.payload,
      };
    }

    case SET_SELECTED_DATES: {
      const {dashboardKey, dates} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ selectedDates: { [x: string]: DateRangeWithTimezone; }; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; ... 14 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {
        ...state,
        selectedDates: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.selectedDates,
          [dashboardKey]: dates,
        },
      };
    }
    case SET_LOADING_DASHBOARD_FILTERS: {
      // @ts-expect-error - TS2322 - Type '{ isDashboardFiltersLoading: boolean; filtersOptions?: JourneyExternalClickFiltersOptions | undefined; selectedDateRange?: DateRangeWithTimezone | undefined; ... 13 more ...; isNavigationUp?: boolean | ... 1 more ... | undefined; }' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
      return {...state, isDashboardFiltersLoading: action.payload};
    }
  }

  // @ts-expect-error - TS2322 - Type 'AnalyticsJourneysExternalClickInsightsState | null' is not assignable to type 'AnalyticsJourneysExternalClickInsightsState'.
  return state;
};
